import React from 'react'
import Helmet from 'react-helmet'
import { useCountryData, GetPaymentConfigByCountryCode } from 'msp-integrations'
import { PaypalPayLaterProps } from './PaypalPayLater.types'

const PaypalPayLater = ({ amount, type, isDarkMode }: PaypalPayLaterProps) => {
  const i18n = useCountryData()
  const currentCountryCode = i18n.locale?.split('_')[1]
  const paymentConfig = GetPaymentConfigByCountryCode(i18n, currentCountryCode)
  if (!paymentConfig?.paypal?.id) return <></>

  return (
    <>
      <Helmet>
        <script
          src={`https://www.paypal.com/sdk/js?client-id=${paymentConfig?.paypal?.id}&currency=EUR&components=messages`}
          data-namespace='PayPalSDK'
        ></script>
      </Helmet>
      <div
        className='pt-4'
        data-pp-message
        data-pp-style-layout='text'
        data-pp-style-logo-type={type === 'checkout' ? 'inline' : 'primary'}
        data-pp-style-text-color={isDarkMode ? 'white' : 'black'}
        data-pp-amount={amount}
      ></div>
    </>
  )
}

export default PaypalPayLater
